export default __webpack_public_path__ + "static/media/MichalG.4e9938d3.jpg";